/**
 * @name removeProtocolFromUrl
 * @description Removes 'http://' or 'https://' from the beginning of a url.
 */
export const removeProtocolFromUrl = (url: string): string =>
  url.replace('http://', '').replace('https://', '');
